<template>
    <v-dialog
        v-model="value"
        max-width="700"
    >
        <v-card class="py-3 px-5">
            <v-container>
                <v-form ref="task_form" v-model="valid">
                    <v-row v-if="showEmailTemplate">
                        <v-col>
                            <div class="d-block" v-if="createEmailTemplate">
                                <v-text-field
                                    v-model="emailTemplateName"
                                    label="Email Template Name"
                                    outlined
                                    required
                                    :rules="[value => !!value || 'Required.']"
                                />
                            </div>
                            <div>
                                <!-- <vue-editor 
                                    v-model="item.emailTemplateContent" 
                                    :editorToolbar="customToolbar">
                                </vue-editor> -->
                                <!-- <div class="d-flex d-block"
                                    v-html="emailTemplateContent">
                                </div> -->
                                <!-- <v-textarea
                                    v-model="emailTemplateContent"
                                    label="Email Template"
                                    v-tinymce="{
                                        plugins: 'link image code',
                                        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | link image',
                                        menubar: false,
                                        height: 300,
                                        setup (editor) {
                                            editor.on('change', () => {
                                                this.$emit('input', editor.getContent());
                                            });
                                        }
                                    }">
                                </v-textarea> -->
                                <v-textarea
                                    v-model="emailTemplateContent"
                                    label="Email Template"
                                    id="editor"> 
                                </v-textarea>
                                <div class="d-flex justify-end">
                                    <v-btn  
                                        small
                                        outlined
                                        color="primary darken-1"
                                        @click="adjustEmailTemplate()">
                                        {{ createEmailTemplate ? 'Create New Template' : 'Update Template' }}
                                    </v-btn>
                                </div>    
                                <!-- :disabled="!emailTemplateName" -->
                                <!-- <div id="editor-container">{{ emailTemplateContent }}</div> -->
                                <!-- <textarea id="editor" name="editor">{{ emailTemplateContent }}</textarea> -->
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
            
            <v-card-actions>
                <v-btn 
                    class="mr-3" 
                    outlined 
                    color="primary darken-1"
                    @click="handleCancel"
                >
                    Cancel
                </v-btn>
                <v-btn 
                    class="white--text" 
                    color="primary darken-1"
                    @click="handleSave"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from 'axios';
    import Cookie from 'js-cookie'
    import appUrls from '../../helpers/environment';

    import { 
        complexityItems, 
        ownerItems,
        priorityItems,
        responsiblePartyItems,
        durationItems, 
        taskTypes,
    } from '../../helpers/constants'

    export default {
        name: 'ProjectStepDetails',

        components: {
            // VueEditor
        },

        props: {
            item: {
                type: Object,
                required: true,
                default: {}
            },
            moduleData: {
                type: Object
            },
            value: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            ownerList () {
                return Object.keys(ownerItems).map(key => ({ text: ownerItems[key] , value: key})).sort((a, b) => a.text.localeCompare(b.text));
            },

            // showEmailTemplate: {
            //     get() {
            //         return this.item.email_template !== '' && this.item.email_template !== null;
            //     },
            //     set(value) {
            //         console.log('Setting showEmailTemplate:', value);
            //         if (!value) {
            //             this.item.email_template = ''; // Clear the email template if toggled off
            //             this.emailTemplateContent = ''; // Clear the content as well
            //         }
            //     }
            // },

            emailTemplateContent: {
                get() {
                    if (!(this.item.email_template && this.emailTemplateArray)) {
                        return '';
                    }

                    const selected_template = this.emailTemplateArray.find(item => item.value === this.item.email_template);
                    return selected_template && selected_template.content ? selected_template.content : '';
                },
                set(value) {
                    console.log('Setting emailTemplateContent:', value);
                    if (this.item.email_template) {
                        const template = this.emailTemplateArray.find(item => item.value === this.item.email_template);
                        if (template) {
                            template.content = value; // Update the content in the emailTemplateArray
                        }
                    }
                }
            }
        },

        watch: {
            showEmailTemplate ( newValue ) {
                return this.item.email_template != '' ? true : false
            },
            'item.email_template': function (newValue) {
                if (!this.createEmailTemplate) {
                    this.showEmailTemplate = newValue !== '' && newValue !== null;
                }
            }
        },

        data: () => ({
            complexityList: Object.keys(complexityItems).map(key => ({ text: complexityItems[key] , value: key})),
            priorityList: Object.keys(priorityItems).map(key => ({ text: priorityItems[key] , value: key})),
            responsiblePartiesList: Object.keys(responsiblePartyItems).map(key => ({ text: responsiblePartyItems[key] , value: key})),
            taskTypesList: Object.keys(taskTypes).map(key => ({ text: taskTypes[key] , value: key})),
            durationList: Object.keys(durationItems).map(key => ({ text: durationItems[key] , value: key})),
            valid: false,
            createEmailTemplate: false,
            emailTemplateSelection: '',
            emailTemplateName: '',
            emailTemplateArray: [],
            showEmailTemplate: false, // Initialize as a separate reactive property
            // quill: null,
            customToolbar: [
                ["bold", "italic", "underline"], 
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [
                    { list: "ordered" }, 
                    { list: "bullet" }
                ], 
                ["image", "link"]
            ]
        }),

        mounted() {
            this.getTemplateOptions().then(() => {
                // Initialize showEmailTemplate based on item.email_template
                this.showEmailTemplate = this.item.email_template !== '' && this.item.email_template !== null;

                // Initialize emailTemplateContent if an email template is already set
                if (this.item.email_template) {
                    const selectedTemplate = this.emailTemplateArray.find(item => item.value === this.item.email_template);
                    this.emailTemplateContent = selectedTemplate ? selectedTemplate.content : '';
                }
            });
            // ...existing code...
        },
    
        methods: {
            async getTemplateOptions() {
                try {
                    const response = await axios.get(`${appUrls.api}/api/admin/email_templates/task_template`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    });

                    console.log('API Response:', response.data); // Log the API response for debugging

                    if (response.data.outcome) {
                        this.emailTemplateArray = response.data.templates.map(item => ({
                            text: item.email_name || 'Unnamed Template', // Fallback for missing names
                            value: item.status_id,
                            content: item.body_text || '[No Content]', // Fallback for missing content
                        }));
                        console.log('Mapped Email Templates:', this.emailTemplateArray); // Log the mapped array for debugging
                    } else {
                        console.error('Failed to fetch email templates: No outcome');
                    }
                } catch (error) {
                    console.error('Error fetching task-related email templates:', error);
                }
            },
            createNewTemplate: function () {
                this.createEmailTemplate = true;
                this.emailTemplateSelection = '';
                this.emailTemplateName = '';
                this.emailTemplateContent = '';
                this.item.email_template = ''; // Ensure email_template is cleared
                this.showEmailTemplate = true; // Ensure the toggle is on
            },

            handleTemplateSelection: function () {
                this.createEmailTemplate = false;

                console.log(this.emailTemplateArray);

                this.emailTemplateSelection = this.item.email_template;
                const selectedTemplate = this.emailTemplateArray.find(item => item.value === this.emailTemplateSelection);
                this.emailTemplateName = selectedTemplate ? selectedTemplate.text : '';
                this.emailTemplateContent = selectedTemplate ? selectedTemplate.content : '';
                this.showEmailTemplate = true; // Ensure the toggle remains on
            },

            handleCancel: function () {
                this.$emit('input', false);
            },

            handleSave: async function () {
                this.valid = this.$refs.task_form.validate();
                if (this.valid) {
                    if ( this.item.responsible_party != 'srg' ) {
                        this.item.owner_id = null;
                    }

                    this.$emit('save', this.item);
                    this.$emit('input', false);
                } else {
                    // Show validation errors
                    this.$refs.task_form.$el.scrollIntoView({ behavior: 'smooth' });
                }
            },

            createEmailTemplateId: function (email_template_name) {
                return email_template_name
                    .toLowerCase()                  // Convert to lowercase
                    .replace(/[^a-zA-Z0-9 ]/g, '')  // Remove non-alphanumeric except spaces
                    .replace(/ /g, '_');            // Replace spaces with underscores
            },

            adjustEmailTemplate: async function () {
                try {
                    if ( this.emailTemplateContent != '' ) {
                        const template_action = this.createEmailTemplate ? 'insert' : 'update'
                        const status_id       = this.createEmailTemplate ? this.createEmailTemplateId(this.emailTemplateName) : this.item.email_template;
                        const body_text       = this.emailTemplateContent
                        const subject_text    = this.createEmailTemplate ? this.emailTemplateName : ''
                        const email_name      = this.createEmailTemplate ? this.emailTemplateName : ''
                        const email_type      = 'task_template'

                        const adjust_email_template = await axios.post(`${appUrls.api}/api/admin/adjust_email_template`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data: {
                                template_action,
                                status_id,
                                body_text,
                                subject_text,
                                email_name,
                                email_type
                            }
                        });

                        if ( adjust_email_template.status === 200 ) {                        
                            this.$emit('triggerUserFeedback', true, 'The email template was saved');
                        } else {
                            this.$emit('triggerUserFeedback', true, 'There was a problem saving the email template', 'error');
                        }
                    } else {
                        this.$emit('triggerUserFeedback', true, 'There must be content to create or update an email template', 'error');                        
                    }
                } catch (error) {
                    console.error('Error updating email template:', error);
                }
            }
        }
    }
</script>

<style scoped>
    .customToolbar {
        border: 1px solid #ccc;
        padding: 10px;
        margin-top: 10px;
        background-color: #f9f9f9;
    }

    .customToolbar img {
        max-width: 100%;
        height: auto;
    }
    .customToolbar a {
        color: #007bff;
        text-decoration: none;
    }
    .customToolbar a:hover {
        text-decoration: underline;
    }
    .customToolbar p {
        margin: 0;
        padding: 0;
    }
    .customToolbar ul {
        list-style-type: disc;
        padding-left: 20px;
    }
    .customToolbar li {
        margin-bottom: 5px;
    }
    .customToolbar h1, .customToolbar h2, .customToolbar h3 {
        margin: 0;
        padding: 0;
    }
    .customToolbar h1 {
        font-size: 24px;
    }
    .customToolbar h2 {
        font-size: 20px;
    }
    .customToolbar h3 {
        font-size: 18px;
    }
    .customToolbar blockquote {
        border-left: 4px solid #ccc;
        padding-left: 10px;
        margin: 0;
        font-style: italic;
    }
    .customToolbar pre {
        background-color: #f0f0f0;
        padding: 10px;
        overflow-x: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/dialogs/ManageEmailTemplates.vue